import themes from '@codesandbox/common/lib/themes';

export default themes;
